export const subPermissionKeys = {
  groupKey: 'permisoPendiente',
  readCampus: 'campus-listar-sedes',
  readOffers: 'offers-listar-ofertas',
  readOffersById: 'offers-obtener-oferta',
  readOfferByPeriod: 'offers-listar-periodos-por-oferta',
  readCourses:
    'periods_education_levels-buscar-periods-and-education_levels-listar-aula-niveleconomico',
};
